import { EntDirectoryInfoName } from "../../../models/directoryInfoName";
import { EntInitialFilterName } from "../../../models/filters/initialFilterName";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { agroApi } from "../api";
import { Paths } from "../../../paths";

export const realEstateConditionsApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getRealEstateConditionsList: builder.query<ResponseDataGet<EntDirectoryInfoName>, EntInitialFilterName>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.realestateconditions }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getRealEstateConditionsById: builder.query<ResponseDataGet<EntDirectoryInfoName>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.realestateconditions }/${ id }`,
		method: 'GET',
	  }),
	}),

	addRealEstateConditions: builder.mutation<ResponseDataGet<EntDirectoryInfoName>, EntDirectoryInfoName>({
	  query: (body) => ({
		url: `${ Paths.handbooks.realestateconditions }`,
		method: "POST",
		body: JSON.stringify(body),
	  }),
	}),

	editRealEstateConditions: builder.mutation<ResponseDataGet<EntDirectoryInfoName>, EntDirectoryInfoName>({
	  query: (body) => ({
		url: `${ Paths.handbooks.realestateconditions }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),

	deleteRealEstateConditions: builder.mutation<ResponseDataGet<EntDirectoryInfoName>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.realestateconditions }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddRealEstateConditionsMutation,
  useDeleteRealEstateConditionsMutation,
  useEditRealEstateConditionsMutation,
  useLazyGetRealEstateConditionsListQuery
} = realEstateConditionsApi;
